/**
 * Движение · Ф2.2 — Motion One (крошечный, без React).
 *
 * Правило Минимала: фон спокоен, движение — только на смене экрана и на моментах
 * успеха (праздничные эффекты придут с занятием). «Поменьше движения» в системе
 * уважаем: при `prefers-reduced-motion` просто ничего не двигаем.
 */

import { animate } from "motion";

const reduced = () => !!window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

const EASE = [0.4, 0, 0.2, 1] as [number, number, number, number];

/** Появление экрана: лёгкий подъём снизу. */
export function enterScreen(el: HTMLElement): void {
  if (reduced()) return;
  animate(el, { opacity: [0, 1], y: [8, 0] }, { duration: 0.34, ease: EASE });
}

/** Появление «острова» навигации на старте. */
export function enterNav(el: HTMLElement): void {
  if (reduced()) return;
  animate(el, { opacity: [0, 1], y: [22, 0] }, { duration: 0.44, delay: 0.12, ease: EASE });
}

/** Плавный набор числа: «слов в словаре» приятнее видеть растущим. */
export function countUp(el: HTMLElement, to: number, duration = 0.7): void {
  if (reduced() || to <= 0) { el.textContent = to.toLocaleString("ru-RU"); return; }
  animate(0, to, {
    duration,
    ease: EASE,
    onUpdate: (v) => { el.textContent = Math.round(v).toLocaleString("ru-RU"); },
  });
}
